document.addEventListener("DOMContentLoaded", () => {
  // const buttons = document.querySelectorAll(".shopify-section.shopify-section--main-product product-recommendations.block .complementary-products .horizontal-product-card__info button:not(.\\@large\\:horizontal-product-card__button");
  // buttons.forEach((button) => {
  //   // Removing the existing classes to only apply the button one
  //   button.className = "button";
  // });
  ready(".shopify-section.shopify-section--main-product product-recommendations.block .complementary-products .horizontal-product-card__info button:not(.\\@large\\:horizontal-product-card__button)", (button) => {
    console.log("Complementary product button found:", button);
    // Keep the "@narrow:..." class: it's what hides this button once the
    // card container query switches to the large layout (>= 450px).
    button.classList.remove("link");
    button.classList.add("button");
  });
});

export function ready(selectors, fn) {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  var selectorArray = typeof selectors === 'string' ? [selectors] : selectors;

  function handleElements() {
    selectorArray.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        if (!element.dataset.readyHandled) {
          element.dataset.readyHandled = "true";
          fn.call(element, element);
        }
      });
    });
  }

  // Esegui subito su tutti gli elementi già presenti
  handleElements();

  // Osserva il DOM per nuovi elementi
  var observer = new MutationObserver(function () {
    handleElements();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}